module.exports = __webpack_public_path__ + "img/etapa2.4232931a.png";